import { Sprout } from "lucide-react";

import { useIsMobile } from "../lib/useIsMobile";
import { fonts, radius, tokens } from "../styles/theme";
import { TAB_TITLES, type TabId } from "./TabBar";

export function Header({ tab }: { tab: TabId }) {
  const isMobile = useIsMobile();

  return (
    <header
      style={{
        borderBottom: `1px solid ${tokens.line}`,
        background: tokens.page,
        padding: isMobile ? "14px 16px 12px" : "20px 20px 16px",
        maxWidth: "960px",
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <div
        aria-hidden
        style={{
          width: "34px",
          height: "34px",
          borderRadius: radius.sm,
          background: tokens.sage,
          color: "#fff",
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
        }}
      >
        <Sprout size={18} strokeWidth={2} />
      </div>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: "18px",
            color: tokens.ink,
            lineHeight: 1.1,
            letterSpacing: "-0.01em",
          }}
        >
          Grow Ops
        </div>
        {!isMobile && (
          <div
            style={{
              fontFamily: fonts.mono,
              fontSize: "10px",
              color: tokens.muted,
              letterSpacing: "0.04em",
              marginTop: "2px",
            }}
          >
            brookfield · {TAB_TITLES[tab].toLowerCase()}
          </div>
        )}
      </div>
    </header>
  );
}
